import { useEffect, useState } from 'react';
import { Flame, Shield, X } from 'lucide-react';
import { trackStreakMilestoneToast } from '@/lib/analytics';

const MILESTONES = [7, 14, 30, 100] as const;

const MILESTONE_MESSAGES: Record<number, string> = {
  7: "7-day streak! You're on fire! +1 Streak Freeze",
  14: '14-day streak! Unstoppable! +1 Streak Freeze',
  30: '30-day streak! Legendary! +1 Streak Freeze',
  100: '100-day streak! MotoWalla OG! +1 Streak Freeze',
};

function getMilestoneKey(day: number): string {
  return `streak-milestone-${day}`;
}

export function StreakMilestoneToast({ currentStreak }: { currentStreak: number }) {
  const [visible, setVisible] = useState(false);
  const [milestone, setMilestone] = useState<number | null>(null);

  useEffect(() => {
    const hit = MILESTONES.find((m) => currentStreak === m);
    if (!hit) return;

    const key = getMilestoneKey(hit);
    if (sessionStorage.getItem(key)) return;

    sessionStorage.setItem(key, '1');
    setMilestone(hit);
    setVisible(true);
    trackStreakMilestoneToast('shown', hit);

    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, [currentStreak]);

  if (!visible || !milestone) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 animate-bounce">
      <div className="flex items-center gap-3 rounded-2xl border border-orange-500/30 bg-gradient-to-r from-orange-500/90 to-red-500/90 px-5 py-3 shadow-2xl backdrop-blur">
        <Flame className="h-6 w-6 text-white animate-pulse" />
        <span className="text-sm font-bold text-white">
          {MILESTONE_MESSAGES[milestone]}
        </span>
        <Shield className="h-5 w-5 text-cyan-200" />
        <button
          onClick={() => {
            trackStreakMilestoneToast('dismissed', milestone);
            setVisible(false);
          }}
          aria-label="Dismiss streak milestone toast"
          className="ml-1 rounded-full p-1 text-white/70 hover:text-white hover:bg-white/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
